import { z } from 'zod';

export const componentTypes = [
  { value: 'text', label: 'Text Field', icon: 'FiType' },
  { value: 'textarea', label: 'Text Area', icon: 'FiAlignLeft' },
  { value: 'email', label: 'Email Field', icon: 'FiMail' },
  { value: 'file', label: 'File Upload', icon: 'FiPaperclip' },
  { value: 'markdown', label: 'Markdown Content', icon: 'FiFileText' },
  { value: 'select', label: 'Dropdown Select', icon: 'FiList' }
];

// Initial component state
export const initialComponentState = {
  type: 'text',
  name: '',
  required: false,
  placeholder: '',
  content: '',
  options: [],
  rememberValue: false,
  maxFiles: 5,
  multipleFiles: false
};

// Form validation schema
export const formSchema = z.object({
  name: z.string().min(1, 'Form name is required'),
  slug: z.string()
    .min(1, 'Form URL is required')
    .regex(/^[a-z0-9-]+$/, 'URL can only contain lowercase letters, numbers, and hyphens'),
  password: z.string().optional().nullable(),
  organization: z.string().min(1, 'Organization is required'),
  components: z.array(z.any()).min(1, 'At least one component is required'),
  online: z.boolean()
});

export const generateSlug = (name) => {
  return name
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}; 